import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import queryString from "query-string";

import { PAGE_TYPE, setPageTitle } from "containers/App/reducer";

import * as nextReducer from "containers/Next/NextReducer";
import * as setupReducer from "containers/Setup/reducer";
import * as globalReducer from "containers/App/reducer";
import * as chatGPTReducer from "containers/ChatGPT/reducer";
import * as chatAppReducer from "containers/ChatApp/reducer";
import * as blueprintReducer from "containers/Blueprint/reducer";
import { decodeUiState } from "containers/ChatApp/reducer";
import { getAuthenticated } from "containers/Login/reducer";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import ChatGPTWrapper from "components/Next/ChatGPTWrapper";
import Next from "containers/Next/Next";
import { isEnabled } from "utils/featureFlags";
import { selectIsOpenClawConnected } from "containers/OpenClaw/openClawSlice";
import { disconnectFromOpenClaw } from "containers/OpenClaw/openClawThunk";

const getId = (props) =>
  props && props.reportId
    ? props.reportId
    : props && props.match && props.match.params && props.match.params.reportId
      ? props.match.params.reportId
      : "new";

const getDatasetId = (props) =>
  props && props.datasetId
    ? props.datasetId
    : props && props.match && props.match.params && props.match.params.datasetId
      ? props.match.params.datasetId
      : "new";

const getBlueprintId = (props) => {
  const propsBp =
    props && props.blueprintId
      ? props.blueprintId
      : props && props.match && props.match.params && props.match.params.blueprintId
        ? props.match.params.blueprintId
        : undefined;

  return propsBp;
};

function getReportIdFromRoute(route) {
  if (!route) {
    return undefined;
  }

  const routeComponents = route?.split("/");
  const REPORT_ID_INDEX = 3;

  return routeComponents?.[REPORT_ID_INDEX];
}

const getParamsObj = (props) => {
  const queryParams = props.location.search;
  const paramsObj = queryParams ? queryString.parse(queryParams) : undefined;

  return paramsObj;
};

const getSelectedBlueprintId = (props) => {
  const paramsObj = getParamsObj(props);

  const paramsBp = paramsObj && paramsObj.blueprintId ? paramsObj.blueprintId : undefined;

  return paramsBp;
};

class NextWrapperContainer extends React.Component {
  constructor(props) {
    super(props);
    const blueprintId = getBlueprintId(props);
    const datasetId = getDatasetId(props);
    const isChatGPT =
      (isEnabled("chat-aible-consumer") && !isEnabled("aible-optimize")) ||
      datasetId === "new" ||
      datasetId === undefined;
    setPageTitle(PAGE_TYPE.DEFAULT);

    const retDatasetId = props.overrideOptions?.datasetId ?? datasetId;

    props
      .init(
        getId(props),
        retDatasetId,
        getBlueprintId(props),
        isChatGPT,
        getSelectedBlueprintId(props),
        props?.uiState,
        props?.skipAskIntro,
        props?.reportLabelOverride,
        props.overrideOptions?.scrollToSection
      )
      .then((d) => {
        if (isEnabled("chat-aible")) {
          props.initChatGPT();
        }

        if (blueprintId === "__dash") {
          console.log("what are my props?", props, d);
          props.updateActiveTab(getId(props), "NLQ Dashboard");
          console.log("DASHBOARD MODE!");
        }
        if (blueprintId !== undefined && blueprintId !== null) {
          props.initChatAppHelper(blueprintId, props.overrideOptions);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  shouldComponentUpdate(nextProps) {
    return (
      this.props.isLoading !== nextProps.isLoading ||
      this.props.id !== nextProps.id ||
      this.props.blueprintId !== nextProps.blueprintId ||
      this.props.datasetId !== nextProps.datasetId ||
      (this.props.activeTab !== "CHATGPT" && nextProps.activeTab === "CHATGPT") ||
      (this.props.activeTab === "CHATGPT" && nextProps.activeTab !== "CHATGPT") ||
      (this.props.activeTab !== "KPI DASHBOARD" && nextProps.activeTab === "KPI DASHBOARD") ||
      (this.props.activeTab === "KPI DASHBOARD" && nextProps.activeTab !== "KPI DASHBOARD") ||
      this.props.uiState?.type !== nextProps.uiState?.type ||
      this.props.isAuthenticated !== nextProps.isAuthenticated ||
      this.props.isOpeningComparison !== nextProps.isOpeningComparison ||
      this.props.isCreatingFocusedDataset !== nextProps.isCreatingFocusedDataset ||
      this.props.isTemplateLoading !== nextProps.isTemplateLoading ||
      this.props.optimizeSetup !== nextProps.optimizeSetup ||
      this.props.isCreatingOptimize !== nextProps.isCreatingOptimize
    );
  }

  componentWillUnmount() {
    this.props.resetNext("new");
    this.props.resetCurrentNextId();
    this.props.resetSetup();
    this.props.resetChatGPT();
    this.props.resetChatApp();
    this.props.updateIsTemplateLoading(false);
    if (this.props.isOpenShellConnected) {
      this.props.disconnectFromOpenClaw();
    }
  }

  render() {
    const {
      id,
      activeTab,
      datasetId,
      blueprintId,
      blueprint,
      optimizeSetup,
      isCreatingOptimize,
      chatType,
      previousReportData
    } = this.props;
    const isChatApp = blueprint?.wizard?.isChatApp;
    const appDatasetId = blueprint?.wizard?.steps?.[0]?.datasetId;
    const hasAppDatasetId = isChatApp && appDatasetId !== undefined;

    if (
      this.props.isLoading ||
      this.props.isTemplateLoading ||
      !this.props.isAuthenticated ||
      this.props.isOpeningComparison === true ||
      (this.props.isCreatingFocusedDataset === true && (id === "new" || id === undefined))
    ) {
      return (
        <div
          style={{
            height: "calc(100vh - 60px)",
            margin: "40vh auto",
            display: "flex",
            flexDirection: "column",
            alignItems: "center"
          }}
        >
          <LoadingIndicator />
          {this.props.isCreatingFocusedDataset === true && (id === "new" || id === undefined) && (
            <div>{"Saving What's Changed focus, please do not navigate away from this page..."}</div>
          )}
          {activeTab === "CHATGPT" && "Loading data and starting chat..."}
        </div>
      );
    }

    if (isCreatingOptimize) {
      return (
        <div
          style={{
            height: "calc(100vh - 60px)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <LoadingIndicator />
          <div>{"Creating Models..."}</div>
        </div>
      );
    }

    // Adding logic to check for agents with datasetIds in the first step so that analytics
    // agents have access to dashboard/explore even before a chat/save url redirect
    if (
      activeTab === "CHATGPT" ||
      activeTab === "NLQ DASHBOARD" ||
      activeTab === "KPI DASHBOARD" ||
      (datasetId === "new" &&
        !hasAppDatasetId &&
        optimizeSetup?.nextId === undefined &&
        chatType !== "OPENSHELL" &&
        blueprint?.wizard?.openshellConfig === undefined)
    ) {
      return <ChatGPTWrapper id={id} blueprintId={blueprintId} previousReportData={previousReportData} />;
    }

    return (
      <Next
        {...this.props}
        datasetId={hasAppDatasetId ? appDatasetId : datasetId}
        previousReportData={previousReportData}
      />
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    init: (
      id,
      datasetId,
      blueprintId,
      forceExploreCreate,
      selectedBlueprintId,
      uiState,
      skipAskIntro,
      reportLabelOverride,
      scrollToSection
    ) =>
      dispatch(
        nextReducer.init(
          id,
          datasetId,
          true,
          blueprintId,
          forceExploreCreate,
          undefined,
          selectedBlueprintId,
          uiState,
          undefined,
          undefined,
          undefined,
          undefined,
          skipAskIntro,
          reportLabelOverride,
          scrollToSection
        )
      ),
    initChatGPT: () => dispatch(chatGPTReducer.init()),
    resetNext: (id) => {
      dispatch(nextReducer.updateNext(id, undefined));
      dispatch(globalReducer.updateIsSkipNextInit(undefined));
    },
    resetCurrentNextId: () => {
      dispatch(nextReducer.updateCurrentNextId("new"));
    },
    resetChatGPT: () => {
      dispatch(chatGPTReducer.resetGPT());
      dispatch(globalReducer.updateIsSkipChatGPTInit(undefined));
      dispatch(globalReducer.updateIsSkipChatGPTReset(undefined));
    },
    resetChatApp: () => {
      dispatch(chatAppReducer.resetChatApp());
    },
    resetSetup: () => dispatch(setupReducer.resetSetupToDefault("new")),
    initChatAppHelper: (chatApp, overrideOptions) =>
      dispatch(chatGPTReducer.initChatAppHelper(chatApp, undefined, undefined, undefined, overrideOptions)),
    updateActiveTab: (id, activeTab) => dispatch(nextReducer.updateActiveTab(id, activeTab)),
    updateIsTemplateLoading: (isTemplateLoading) => dispatch(globalReducer.updateIsTemplateLoading(isTemplateLoading)),
    disconnectFromOpenClaw: () => dispatch(disconnectFromOpenClaw())
  };
};
const mapStateToProps = (state, ownProps) => {
  const route = state?.router?.location?.pathname;
  const routeId = getReportIdFromRoute(route);

  const id = ownProps.reportId ?? routeId ?? getId(ownProps);

  const datasetId = getDatasetId(ownProps);
  const blueprintId = getBlueprintId(ownProps);

  const paramsObj = getParamsObj(ownProps);

  let uiState = globalReducer.getUiState(state);
  if (paramsObj?.["ui-state"]) {
    const paramsUiState = decodeUiState(paramsObj?.["ui-state"]);
    if (paramsUiState) {
      uiState = paramsUiState;
    }
  }
  let overrideOptions;
  if (paramsObj?.datasetId && !isNaN(Number(paramsObj?.datasetId))) {
    if (!overrideOptions) {
      overrideOptions = {};
    }
    overrideOptions.datasetId = Number(paramsObj.datasetId);
  }
  if (paramsObj?.artifactId && !isNaN(Number(paramsObj?.artifactId))) {
    if (!overrideOptions) {
      overrideOptions = {};
    }
    overrideOptions.artifactId = Number(paramsObj.artifactId);
  }

  const locationState = ownProps?.location?.state;
  const skipAskIntro = locationState?.skipAskIntro;
  const reportLabelOverride = locationState?.reportLabel;
  const previousReportData = locationState?.previousReportData;

  if (paramsObj?.scrollToSection) {
    if (!overrideOptions) {
      overrideOptions = {};
    }
    overrideOptions.scrollToSection = paramsObj.scrollToSection;
  }

  return {
    id: id,
    isAuthenticated: getAuthenticated(state),
    uiState: uiState,
    datasetId: datasetId,
    overrideOptions: overrideOptions,
    isLoading: globalReducer.getIsNextLoading(state),
    isOpeningComparison: globalReducer.getIsOpeningComparison(state),
    isCreatingFocusedDataset: globalReducer.getIsCreatingFocusedDataset(state),
    activeTab: nextReducer.getActiveTab(state, id),

    blueprintId: blueprintId,
    blueprint: blueprintReducer.getBlueprint(state, blueprintId),
    isTemplateLoading: globalReducer.getIsTemplateLoading(state),
    optimizeSetup: chatGPTReducer.getOptimizeSetup(state),
    isCreatingOptimize: chatGPTReducer.getIsCreatingOptimize(state),
    chatType: chatGPTReducer.getChatType(state),
    skipAskIntro: skipAskIntro,
    reportLabelOverride: reportLabelOverride,
    previousReportData: previousReportData,
    isOpenShellConnected: selectIsOpenClawConnected(state)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(NextWrapperContainer);
